import { render, staticRenderFns } from "./PositionsManagement.vue?vue&type=template&id=1f897de8&scoped=true"
import script from "./PositionsManagement.vue?vue&type=script&lang=ts"
export * from "./PositionsManagement.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PositionsManagement.vue?vue&type=style&index=0&id=1f897de8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./PositionsManagement.vue?vue&type=style&index=1&id=1f897de8&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1f897de8",
  null
  ,true
)

export default component.exports